<template>
    <div>
        <!-- Top Nav -->
        <b-navbar toggleable="lg" type="light" variant="light" class="px-4">
            <!-- Logo -->
            <router-link to="/"
                ><img src="/img/brand/OMS Logo.svg"
            /></router-link>

            <b-navbar-nav class="ml-auto">
                <b-form-select
                    v-model="customer_id" 
                    :options="customers"
                    text-field="name"
                    value-field="id"
                ></b-form-select>

                <b-nav-item-dropdown right>
                    <!-- Using 'button-content' slot -->
                    <template #button-content>
                        <em>{{ user.email }}</em>
                    </template>
                    <b-dropdown-item to="/customer-portal/profile"
                    >Profile</b-dropdown-item>

                    <b-dropdown-item @click="logout()"
                        >Sign Out</b-dropdown-item
                    >
                </b-nav-item-dropdown>
                
            </b-navbar-nav>
        </b-navbar>
        <b-navbar
            toggleable="lg"
            type="light"
            variant="light"
            class="px-4 py-4 border-top border-bottom"
        >
            <b-navbar-nav>
                <b-button
                    variant="primary"
                    class="mr-4 shadow-sm"
                    to="/customer-portal/new-service"
                >
                    <b-icon-plus-circle variant="light" class="mr-1">
                    </b-icon-plus-circle>
                    Create Service Request
                </b-button>
                <b-nav-item>
                    <router-link to="/customer-portal/service-requests">
                        <b-icon-list-check class="mr-1"> </b-icon-list-check>
                        Services
                    </router-link>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>
<script>
export default {
    name: 'customer-portal-navbar',
    data: () => ({
        customer_id: null,
    }),
    computed: {
        user() {
            console.log("this.$store.state.user",this.$store.state.user);
            return this.$store.state.user || {}
        },
        customers() {
            return this.$store.getters['userCustomers']
        },
    },
    watch: {
        customer_id: function(val) {
            this.$store.commit(
                'customerPortal/SET_CUSTOMER',
                this.customers.find(x => x.id === val)
            )
        },
        
    },
    mounted() {
        this.customer_id = this.customers[0].id
        this.$store.commit('customerPortal/SET_CUSTOMER', this.customers[0])
        
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
            this.$router.push('/login')
            return false
        },
    },
}
</script>
<style scoped></style>
